/* eslint-disable consistent-return */
import * as LocalStoreService from 'helper/LearningSpaceServices/LocalStore';
import { user } from 'helper/currentUser';

export async function saveAllDSOsToS3() {
  const allLocalDSOs = await LocalStoreService.getAllDataSyncObjects();
  if (allLocalDSOs.length > 0) {
    try {
      const stringifiedDSOs = JSON.stringify(allLocalDSOs);
      const fileName = `${user.id()}_${new Date().getTime()}.json`;
      const url = window.constants.s3BucketUrl + 'userDataSyncBackup/' + fileName;

      return fetch(url, {
        method: 'put',
        headers: { 'Content-type': 'application/json; charset=utf-8' },
        body: stringifiedDSOs
      });
    } catch (e) {
      console.log('error in sending DSOs to S3', e);
      window.bugsnagClient && window.bugsnagClient.notify(e);
      // throw new Error('error in sending DSOs to S3', e);
    }
  } else {
    return Promise.resolve();
  }
}

window.saveAllDSOsToS3 = saveAllDSOsToS3;
